import { render, staticRenderFns } from "./ComboboxParcelasStatus.vue?vue&type=template&id=be041a72"
import script from "./ComboboxParcelasStatus.vue?vue&type=script&lang=js"
export * from "./ComboboxParcelasStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports